import api from './api'

const sendNotifyToSegment = data =>
  api({
    method: 'post',
    baseURL: process.env.SERVER,
    url: '/api/crm/segments/send',
    data,
  })

const getClientsCountInSegment = params =>
  api({
    method: 'get',
    baseURL: process.env.SERVER,
    url: '/api/crm/segments/amount',
    params,
  })

const createSegment = data =>
  api({
    method: 'post',
    baseURL: process.env.SERVER,
    url: '/api/crm/segments',
    data,
  })

const getSegments = params =>
  api({
    method: 'get',
    // baseURL: process.env.SERVER,
    url: 'https://segmentation-service.pilki.com/api/v1/segments?offset=0&limit=1000',
    params,
  })

const updateSegment = ({ data, id }) =>
  api({
    method: 'patch',
    baseURL: process.env.SERVER,
    url: `/api/crm/segments/${id}`,
    data,
  })

const deleteSegment = ({ data, id }) =>
  api({
    method: 'delete',
    baseURL: process.env.SERVER,
    url: `/api/crm/segments/${id}`,
    data,
  })

const downloadSegments = data =>
  api({
    method: 'post',
    baseURL: process.env.SERVER,
    url: `/api/crm/segments/export`,
    data,
  })

const getSegmentsLogs = () =>
  api({
    method: 'get',
    baseURL: process.env.SERVER,
    url: '/api/crm/segments/logs',
  })

const getSegmentSendingStat = params =>
  api({
    method: 'get',
    baseURL: process.env.NOTIFY_SERVER,
    url: '/log/batch',
    params,
  })

const getSegmentFullStat = id =>
  api({
    method: 'get',
    baseURL: process.env.SERVER,
    url: `/api/crm/segments/conversion/${id}`,
  })

const getClientBonus = id =>
  api({
    method: 'get',
    baseURL: process.env.SERVER,
    url: `/api/crm/customers/${id}/wallet-details`,
  })

export {
  sendNotifyToSegment,
  getClientsCountInSegment,
  createSegment,
  getSegments,
  updateSegment,
  deleteSegment,
  downloadSegments,
  getSegmentsLogs,
  getSegmentSendingStat,
  getSegmentFullStat,
  getClientBonus,
}
